import { Link, useParams } from 'react-router-dom';
import { ArrowLeft, ExternalLink } from 'lucide-react';

/**
 * A report James built. The page itself is served by the API behind login
 * (only its owner and admins can open it); this frame keeps the OS chrome.
 */
export function JamesReport() {
  const { reportId } = useParams<{ reportId: string }>();
  const src = `/api/agent/reports/${reportId}`;
  return (
    <div className="absolute inset-0 flex flex-col bg-surface-secondary">
      <div className="flex flex-none items-center justify-between border-b border-border-light px-4 py-2">
        <Link to="/james" className="flex items-center gap-1.5 text-body-sm text-text-secondary hover:text-text-primary">
          <ArrowLeft className="h-4 w-4" aria-hidden />
          James
        </Link>
        <a href={src} target="_blank" rel="noreferrer" className="flex items-center gap-1.5 text-body-sm text-text-secondary hover:text-text-primary">
          Open on its own
          <ExternalLink className="h-3.5 w-3.5" aria-hidden />
        </a>
      </div>
      <iframe title="James report" src={src} className="min-h-0 w-full flex-1 border-0 bg-white" sandbox="allow-scripts allow-popups" />
    </div>
  );
}
